/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * An abstract base service which is extended by all other services
 *
 * @file BaseService.js
 * @author JP
 * @since 1.0.0
 */

import EventBus from 'eventing-bus';

class BaseService {
  constructor(eventName) {
    this.eventName = eventName;
  }

  /**
   * Services which extend the base service override this method
   *
   * @param {string} eventName - event name
   * @param {Object} event - event payload
   */
  /* eslint-disable class-methods-use-this, no-unused-vars */
  handleEvent(eventName, event) {}
  /* eslint-enable class-methods-use-this, no-unused-vars */

  /**
   * This method will initialize the service by subscribing to the event
   *
   */
  start() {
    // Callback function for the subscribed event
    const callback = (event) => {
      this.handleEvent(this.eventName, event);
    };

    // Subscribing to events
    EventBus.on(this.eventName, callback);
  }

  end() {
    // Unsubscribing the event
    EventBus.unregisterCallbacksForEvent(this.eventName);
  }
}

export default BaseService;
